import { useState, type FormEvent } from 'react'
import { useNavigate } from 'react-router'
import { Box, Button, Input, PasswordInput, Stack, Text } from '@n26/nxd'
import { AuthLayout } from './AuthLayout'
import { Logo } from '@/shared/ui/Logo'
import { useOkta } from './OktaContext'
import { useLocalAuth } from './LocalAuthContext'
import { ROUTES } from '@/shared/routes'
import styles from './LoginPage.module.css'

export const LoginPage = () => {
  const { oktaAuth } = useOkta()
  const { enabled: localAuthEnabled, login } = useLocalAuth()
  const navigate = useNavigate()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [hasError, setHasError] = useState(false)

  const handleOktaLogin = () => {
    void oktaAuth.signInWithRedirect()
  }

  const handleLocalSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    if (login(email, password)) {
      navigate(ROUTES.HOME, { replace: true })
    } else {
      setHasError(true)
    }
  }

  return (
    <AuthLayout>
      <Stack direction='vertical' space='16'>
        <Logo className={styles.logo} />

        <Button
          type='button'
          variant='primary'
          color='teal'
          onClick={handleOktaLogin}
        >
          Log in with Okta
        </Button>

        {localAuthEnabled && (
          <>
            <Text variant='small' align='center'>
              or
            </Text>

            <form onSubmit={handleLocalSubmit} noValidate>
              <Stack direction='vertical' space='16'>
                <Input
                  id='email'
                  name='email'
                  type='email'
                  autoComplete='email'
                  required
                  label='Email'
                  value={email}
                  onChange={e => {
                    setEmail(e.currentTarget.value)
                    setHasError(false)
                  }}
                />

                <PasswordInput
                  id='password'
                  name='password'
                  autoComplete='current-password'
                  required
                  label='Password'
                  value={password}
                  onChange={e => {
                    setPassword(e.currentTarget.value)
                    setHasError(false)
                  }}
                />

                {hasError && (
                  <Box
                    id='login-errors'
                    role='alert'
                    padding='12'
                    borderRadius='8'
                    backgroundColor='rhubarb-alternate'
                  >
                    <Text variant='small' color='rhubarb'>
                      Email or password is incorrect.
                    </Text>
                  </Box>
                )}

                <Button
                  type='submit'
                  variant='secondary'
                  color='teal'
                  disabled={!email || !password}
                >
                  Log in
                </Button>
              </Stack>
            </form>
          </>
        )}
      </Stack>
    </AuthLayout>
  )
}
